<template>
    <!-- user && ((user_type == 'admin' || (user_type == 'manager' && (manager_can_edit_this_user || !viewedUser))) || (viewedUser != null && viewedUser.id == user.id)) -->
    <div v-if="user && ( (viewedUser != null && viewedUser.id == user.id) || (user_type == 'admin' || (user_type == 'manager' && (manager_can_edit_this_user || !viewedUser))) )"
        style="padding: 20px">
        <va-page-header style="margin-bottom: 40px; border: 1px solid transparent">

            <div slot="title">
                <va-button class="back_button" @click.native="$router.go(-1)" type="default" size="lg">
                    <va-icon type="chevron-left"></va-icon>
                </va-button>

                <span>{{ name == '' ? 'USERNAME' : getUpperCaseName(name)}}</span>
                <span class='status' v-if="viewedUser == null">{{ _('Draft') }}</span>
            </div>

            <div slot="actions">
                <va-button
                    v-if="viewedUser && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || (viewedUser && viewedUser.get('username') == user.get('username')))"
                    type="primary" @click.native="updateUser" size="lg">
                    {{ _('UPDATE') }}
                </va-button>

                <va-button
                    v-if="viewedUser == null && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                    :class="{no_click: loading}" size="lg" type="primary" @click.native="registerUser">
                    <span>{{ _('CREATE') }}</span>
                </va-button>
            </div>

        </va-page-header>

        <va-form type="vertical" ref="form">
            <va-row :gutter="12">

                <va-column :lg="6">

                    <va-row :gutter="12">

                        <va-column :lg="6">
                            <span class="field_label">{{ _('Name') }}</span>
                            <va-input v-model="name" showClean name="name" :placeholder="_('Name')"
                                :rules="[{type:'required'}]" />
                        </va-column>

                        <va-column :lg="6">
                            <span class="field_label">{{ _('Email') }}</span>
                            <va-input v-model="email" :disabled="viewedUser != null" :showClean="!viewedUser"
                                :placeholder="_('Email')" name="email" :rules="[{type:'required'}]" />
                        </va-column>

                    </va-row>

                    <va-row :gutter="12">

                        <va-column v-if="!viewedUser" :lg="6">
                            <span class="field_label">{{ _('Password') }}</span>
                            <va-input v-model="password" type="password" name="password" :placeholder="_('Password')" />
                        </va-column>

                        <va-column v-else :lg="6" style="margin-top: 30px">
                            <span class="field_label">{{ _('Change Password') }}</span>
                            <va-input v-model="password" type="password" name="password"
                                :placeholder="_('New Password')" />
                            <br>
                            <va-input v-model="confirmPassword" type="password" name="password"
                                :placeholder="_('Confirm Password')" />
                        </va-column>
                    </va-row>

                    <va-row :gutter="12">
                        <va-column
                            v-if="!viewedUser || (viewedUser && viewedUser.id != user.id && user_type =='admin' && (viewedUser.get('type') == 'manager' || viewedUser.get('type') == 'user'))"
                            :lg="6" :md="6" :sm="6">
                            <span class="field_label">{{ _('Type') }}</span>
                            <va-radio-group v-model="type">
                                <va-radio-btn v-show="!viewedUser && user_type == 'admin'" label="admin">
                                    {{ _('Admin') }}</va-radio-btn>
                                <va-radio-btn v-show="user_type == 'admin'" label="manager">
                                    {{ _('Manager') }}</va-radio-btn>
                                <va-radio-btn v-show="user_type == 'admin' || user_type == 'manager'" label="user"
                                    checked>{{ _('User') }}</va-radio-btn>
                                <va-radio-btn v-show="!viewedUser && (user_type == 'admin' || user_type == 'manager')"
                                    label="guest">{{ _('Guest') }}</va-radio-btn>
                            </va-radio-group>
                        </va-column>
                    </va-row>
                </va-column>

                <va-column :lg="6">
                    <va-row :gutter="12" style="float: right; margin-right: 13px">

                        <va-column :lg="12">
                            <span class="field_label">{{ _('Photo') }}</span>
                            <div
                                style="position: relative; display: flex; justify-content: center; align-items: center;">
                                <croppa
                                    :class="{image_uploading_status: imageUploadingLoader, click: loadingUserProfile}"
                                    :key="croppaKey" style="margin-right: -18px; " v-model="profilePic" :width="250"
                                    :height="250" :placeholder="getPlaceholderForProfileSelector"
                                    :placeholder-font-size="0" :disabled="false" :prevent-white-space="true"
                                    :show-remove-button="true" :remove-button-color="'red'"
                                    @image-remove="handleImageRemove" @move="handleCroppaMove" @zoom="handleCroppaZoom">
                                    <img v-if='!pictureChanged' :src="profilePicUrl" slot="initial"
                                        @load="imageWasLoaded">

                                </croppa>

                                <div v-if="imageUploadingLoader" style="position: absolute">
                                    {{ _('uploading') }}...
                                </div>
                            </div>
                        </va-column>

                    </va-row>
                </va-column>

            </va-row>

            <va-row :gutter="12" v-if="type == 'Admin'">
                <va-column :lg="12" :sm="12" :md="12">
                    <hr>
                </va-column>
            </va-row>

            <va-row>
                <va-column class="user_registeration_department" :lg="12" :sm="12" :md="12" :xs="12"
                    v-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager')) && (type == 'manager' || type == 'user')"
                    style="padding: 0">
                    <span class="field_label">{{ _('Department') }}</span>
                    <va-select name="department" v-model="selected_departments" :multiple="true" :noUncheck="true"
                        :options="getDeparts" :placeholder="_('Department')">
                    </va-select>
                </va-column>
            </va-row>

            <va-row :gutter="0"
                v-if="type == 'user' && (user.get('roles').includes('admin') || user.get('roles').includes('manager'))">
                <va-column :lg="12">
                    <va-table hover fullWidth class="datatable">
                        <table :dir="getDirectionStatus">
                            <thead>
                                <tr>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        <va-checkbox @change="setSurveysValue" :checked="surveys" :value="surveys">
                                            {{ _('Survey') }}</va-checkbox>
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        <va-checkbox @change="setArticlesValue" :checked="articles" :value="articles">
                                            {{ _('Articles') }}</va-checkbox>
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        <va-checkbox @change="setFilesValue" :checked="files" :value="files">
                                            {{ _('Files') }}</va-checkbox>
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        <va-checkbox @change="setMapsValue" :checked="maps" :value="maps">
                                            {{ _('Maps') }}</va-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="vertical-align:top">
                                    <td :class="{no_click: !surveys}">
                                        <div>
                                            <va-checkbox-group v-model="surveyRoles" :vertical="true">
                                                <va-checkbox id="1" label="survey-editor">{{
                                                    _('Survey Manager') }}</va-checkbox>

                                                <va-checkbox id="2" label="survey-approver">{{
                                                    _('Survey Design Approver') }}</va-checkbox>
                                                <va-checkbox id="3" label="submission-approver">{{
                                                    _('Submission Approver') }}</va-checkbox>
                                                <va-checkbox id="4" label="submitter">{{
                                                    _('Submitter')
                                                    }}</va-checkbox>
                                                <va-checkbox id="5" label="survey-viewer">{{
                                                    _('Viewer')
                                                    }}</va-checkbox>
                                            </va-checkbox-group>
                                        </div>
                                    </td>

                                    <td :class="{no_click: !articles}">
                                        <div>
                                            <va-checkbox-group v-model="articleRoles" :vertical="true">
                                                <va-checkbox label="article-editor">{{
                                                    _('Article Manager')
                                                    }}</va-checkbox>
                                                <va-checkbox label="article-approver">{{ _('Article Approver') }}
                                                </va-checkbox>
                                                <va-checkbox label="article-creator">{{ _('Article Creator') }}
                                                </va-checkbox>
                                                <va-checkbox label="article-viewer">{{ _('Viewer') }}</va-checkbox>

                                            </va-checkbox-group>
                                        </div>
                                    </td>

                                    <td :class="{no_click: !files}">
                                        <div>
                                            <va-checkbox-group v-model="fileRoles" :vertical="true">
                                                <va-checkbox label="file-editor">{{
                                                    _('File Manager')
                                                    }}</va-checkbox>
                                                <va-checkbox label="file-approver">{{ _('File Approver') }}
                                                </va-checkbox>
                                                <va-checkbox label="file-creator">{{ _('File Creator') }}</va-checkbox>
                                                <va-checkbox label="file-viewer">{{ _('Viewer') }}</va-checkbox>

                                            </va-checkbox-group>
                                        </div>
                                    </td>

                                    <td :class="{no_click: !maps}">
                                        <div>
                                            <va-checkbox-group v-model="mapRoles" :vertical="true">
                                                <va-checkbox label="map-editor">{{
                                                    _('Map Manager')
                                                    }}</va-checkbox>
                                                <va-checkbox label="map-approver">{{ _('Map Approver') }}</va-checkbox>
                                                <va-checkbox label="map-creator">{{ _('Map Creator') }}</va-checkbox>
                                                <va-checkbox label="map-viewer">{{ _('Viewer') }}</va-checkbox>

                                            </va-checkbox-group>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </va-table>
                </va-column>

            </va-row>

            <va-row v-if="viewedUser">
                <va-column :lg="12" :md="12" :sm="12" :xs="12">
                    <hr>
                    <activities />
                </va-column>
            </va-row>
        </va-form>
    </div>

</template>

<script>
    import Parse from "@/main.js"
    import {
        mapGetters,
        mapActions
    } from "vuex";
    import axios from 'axios';
    import Activities from './Activities'

    export default {
        components: {
            Activities
        },
        data() {
            return {
                pictureChanged: false,
                surveys: false,
                articles: false,
                files: false,
                maps: false,
                surveyRoles: [],
                articleRoles: [],
                fileRoles: [],
                mapRoles: [],
                name: '',
                email: '',
                password: '',
                confirmPassword: '',
                type: '',
                profilePic: {},
                profilePicUrl: '',
                viewedUser: null,
                imageUploadingLoader: false,
                loadingUserProfile: false,
                selected_departments: [],
                all_departments_english: [],
                all_departments_pashto: [],
                all_departments_dari: [],
                croppaKey: '',


                // new
                user_type: '',
                fetched_all_departments: [],
                old_departments: [],
                viewed_user_roles: [],
                manager_can_edit_this_user: false,
                roles: [],

            };
        },
        computed: {
            ...mapGetters(["user", "getSystemLanguage", "loading", 'getDirectionStatus', 'getUserRolesFromState', 'getUserDepartmentsFromState']),

            getDeparts() {
                let myDepts = []
                if (this.getSystemLanguage == 'dari') {
                    return this.all_departments_dari
                }
                if (this.getSystemLanguage == 'pashto') {
                    return this.all_departments_pashto
                }
                else {
                    return this.all_departments_english
                }
            },

            getPlaceholderForProfileSelector() {
                if (this.loadingUserProfile) {
                    return this._('Loading...')
                } else {
                    return this._('Choose an image')
                }
            }
        },

        watch: {
            type(val) {

            },
            surveys(val) {
                if (!val) this.surveyRoles = []
            },
            files(val) {
                if (!val) this.fileRoles = []
            },
            maps(val) {
                if (!val) this.mapRoles = []
            },
            articles(val) {
                if (!val) this.articleRoles = []
            },

            async '$route'(to, from) {
                await this.fetchings()
            }
        },

        methods: {
            ...mapActions(['fetchUserRoles']),

            setSurveysValue(val) {
                this.surveys = val
            },
            setArticlesValue(val) {
                this.articles = val
            },
            setFilesValue(val) {
                this.files = val
            },
            setMapsValue(val) {
                this.maps = val
            },

            imageWasLoaded() {
                this.loadingUserProfile = false
            },

            getUpperCaseName(name) {
                return name.toUpperCase()
            },

            // start of profile related methods
            generateImage: function () {
                return new Promise((resovle, reject) => {
                    this.imageUploadingLoader = true
                    var imageName = new Date().getTime();
                    let url = this.profilePic.generateDataUrl()
                    if (url) {
                        this.uploadImage(url, imageName)
                            .then(file => {
                                this.imageUploadingLoader = false
                                resovle(file)
                            })
                    } else {
                        this.imageUploadingLoader = false
                        resovle('')
                    }
                })
            },

            uploadImage(url, name) {
                return new Promise((resolve, reject) => {
                    var parseFile = new Parse.File(name, { base64: url });
                    parseFile.save()
                        .then(function (file) {
                            resolve(file._url)
                        }, function (error) {
                        });

                })
            },

            handleImageRemove() {
                this.pictureChanged = true;
                this.profilePic = {};
                this.croppaKey = Date.now()
            },

            handleCroppaMove() { },
            handleCroppaZoom() { },
            // end of profile related methods

            validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },

            validate() {
                if (!this.validateEmail(this.email)) {
                    this.$notify({
                        group: 'foo',
                        text: this._('Email is invalid'),
                        duration: 4000,
                        position: 'top left',
                        type: 'warn'
                    })
                    return false
                }
                if ((this.selected_departments == null || this.selected_departments.length == 0) && this.type != 'admin' && this.type != 'guest') {
                    this.$notify({
                        group: 'foo',
                        text: this._('Please select a department'),
                        duration: 4000,
                        position: 'top left',
                        type: 'warn'
                    })
                    return false
                }
                if (this.password == '') {
                    this.$notify({
                        group: 'foo',
                        text: this._('Password is required'),
                        duration: 4000,
                        position: 'top left',
                        type: 'warn'
                    })
                    return false
                }

                if (this.password.length < 6) {
                    this.$notify({
                        group: 'foo',
                        text: this._('Password must be atleast 6 characters'),
                        duration: 4000,
                        position: 'top left',
                        type: 'warn'
                    })
                    return false
                }
                return true
            },

            async registerUser() {
                if (this.validate() == false)
                    return false

                var roles = []
                if (this.type == 'user') {
                    if (this.surveyRoles.length != 0) this.surveyRoles.push('surveys')
                    if (this.fileRoles.length != 0) this.fileRoles.push('files')
                    if (this.articleRoles.length != 0) this.articleRoles.push('articles')
                    if (this.mapRoles.length != 0) this.mapRoles.push('maps')
                    roles = [...this.surveyRoles, ...this.fileRoles, ...this.articleRoles, ...this.mapRoles]


                } else if (this.type == 'admin') roles = ['admin']
                else if (this.type == 'manager') roles = ['manager']
                else if (this.type == 'guest') roles = ['guest']

                if (roles.includes('submitter') && roles.includes('submission-approver') || roles.length == 0) {
                    var message = ''
                    if (roles.length == 0) message = 'Please assign user to a role'
                    else message = 'User can not be submitter and submission approver at the same time'
                    this.$notify({
                        group: 'foo',
                        text: this._(message),
                        duration: 4000,
                        position: 'top left',
                        type: 'warn'
                    })
                    return false
                }

                this.$refs.form.validateFields(async result => {
                    if (result.isvalid) {
                        this.$store.commit('setLoading', true)

                        // 1. check if the email exists or not
                        let q = new Parse.Query('User')
                        q.equalTo('email', this.email)
                        let user_result = await q.first()
                        if (!user_result) {
                            // 2. upload the selected image
                            this.generateImage()
                                .then(async image => {
                                    // 3. generate pointers for selected departments
                                    let selected_departments_objects = [];

                                    if (this.type == 'manager' || this.type == 'user') {
                                        for (let i = 0; i < this.selected_departments.length; i++) {
                                            const department_id = this.selected_departments[i];
                                            for (let j = 0; j < this.fetched_all_departments.length; j++) {
                                                const department_object = this.fetched_all_departments[j];
                                                if (department_object.id == department_id) {
                                                    selected_departments_objects.push(department_object)
                                                }
                                            }
                                        }
                                    }

                                    // 4. set object-based roles for this user
                                    var user = new Parse.User();
                                    // 4.1 if the user is admin, the only users with admin role can edit this user
                                    let editRole = new Parse.ACL();
                                    editRole.setPublicReadAccess(true);
                                    editRole.setRoleWriteAccess("admin", true)

                                    // 4.2 if the user is not admin (user is department-based), then users with roles (admin + manager) + user itlself can edit this user
                                    if (this.type == 'user' || this.type == 'guest') {
                                        editRole.setRoleWriteAccess("manager", true)
                                    }
                                    // 4.3 set roles to the user's object
                                    user.setACL(editRole);

                                    // 5. create the user object
                                    user.set("username", this.email);
                                    user.set("password", this.password);
                                    user.set('departments', selected_departments_objects)
                                    user.set("email", this.email);
                                    user.set("name", this.name);
                                    user.set("is_active", true);
                                    user.set("type", this.type);
                                    user.set("roles", roles)
                                    user.set("language", 'english')
                                    if (image == '' || image == null) {
                                        user.set("profilePic", 'https://parse.nepa.gov.af/parse/files/nepa/1558358826639.png');
                                    } else {
                                        user.set("profilePic", image);
                                    }

                                    // 6. save the user to database
                                    await user.save()
                                        .then(async created_user => {

                                            // after saving
                                            // 1. add user to its releavent role, if user is admin, the add it to the admin role, if it is not admin, then it the user to the selected department's roles (we create role to each department), for guest add the user to guest role
                                            // 1.1  for admin and guest
                                            if (this.type == 'admin' || this.type == 'guest') {
                                                await this.assignToThisRole(created_user, this.type)

                                                // 1.2 for department-based users
                                            } else if (this.type == 'manager' || this.type == 'user') {
                                                if (this.type == 'manager') {
                                                    await this.assignToThisRole(created_user, 'manager')
                                                }
                                                for (let i = 0; i < selected_departments_objects.length; i++) {
                                                    const department = selected_departments_objects[i];
                                                    await this.assignToThisRole(created_user, department.get('slug'))
                                                }
                                            }

                                            // 1.3 assign user to the main sections' roles (survey, article, file, map)
                                            if (created_user.get('roles')) {
                                                for (let i = 0; i < created_user.get('roles').length; i++) {
                                                    const role = created_user.get('roles')[i];
                                                    if (role == 'surveys' || role == 'articles' || role == 'files' || role == 'maps') {
                                                        await this.assignToThisRole(created_user, role.substring(0, role.length - 1))
                                                    }
                                                }
                                            }

                                            // end of: user was created, user was assigned to their releavent roles, assign roles to this user's object-based permissions for editing purposes

                                            // 7. send email verification to the user's email
                                            await axios.post(
                                                'https://parse.nepa.gov.af/parse/verificationEmailRequest',
                                                {
                                                    "email": created_user.get('username')
                                                },
                                                {
                                                    "headers": {
                                                        "X-Parse-Application-Id": "nepa",
                                                        "X-Parse-Master-Key": "ag33israr3698",
                                                        "Content-Type": "application/json"
                                                    }
                                                }
                                            ).then(created_user => {
                                                this.$notify({
                                                    group: 'foo',
                                                    text: this._('Verification email was sent'),
                                                    duration: 4000,
                                                    position: 'top left',
                                                    type: 'info'
                                                });

                                            }).catch(e => {
                                                this.$notify({
                                                    group: 'foo',
                                                    title: this._('System Error'),
                                                    text: this._('Error accured while sending Verification email'),
                                                    duration: 4000,
                                                    position: 'top left',
                                                    type: 'info'
                                                });
                                            })

                                            // 9. register the user for chat
                                            if (this.type != 'guest') {
                                                var username = this.email.split(
                                                    "@")[0];
                                                if (username.length < 3) username + '__';
                                                await axios.post(
                                                    'https://nepachat.speensoft.net/api/v1/users.register', {
                                                    username: username,
                                                    email: this.email,
                                                    pass: "passnepa",
                                                    name: this.name,
                                                    secretURL: 'jxMBnFuhLYHF8mQx8'
                                                }).then(res => {

                                                }).catch(e => {
                                                })
                                            }

                                            // 8. create the activities for the above works
                                            if (this.type == 'admin' || this.type == 'guest') {
                                                await this.createActivity(this.name, '/users/' + created_user.id, 'create', null, created_user)

                                            } else if (this.type == 'manager' || this.type == 'user') {
                                                for (let i = 0; i < selected_departments_objects.length; i++) {
                                                    const department = selected_departments_objects[i];
                                                    await this.createActivity(this.name, '/users/' + created_user.id, 'create', department, created_user)
                                                }
                                            }

                                            // 10. show success notification
                                            this.$notify({
                                                group: 'foo',
                                                text: this._('User was registered'),
                                                duration: 4000,
                                                position: 'top left',
                                                type: 'success'
                                            });

                                            // 11. go back to users list
                                            this.$router.go(-1)
                                            this.$store.commit('setLoading', false)
                                        }).catch(e => {
                                            this.$store.commit('setLoading', false)
                                            this.$router.go(-1)
                                        })
                                })
                        } else {
                            this.$store.commit('setLoading', false)
                            this.$notify({
                                group: 'foo',
                                text: this._('The email has already been taken'),
                                duration: 4000,
                                position: 'top left',
                                type: 'error'
                            })
                        }
                    }
                })
            },

            async assignToThisRole(user, role_name) {
                var role;
                var query = new Parse.Query(Parse.Role);
                query.equalTo("name", role_name);
                role = await query.first();

                if (role) {
                    await role.getUsers().add(user)
                    await role.save().then(res => {

                    }).catch(e => {


                    });
                }
            },

            async removeUserFromRole(user, role_name) {
                var role;
                var query = new Parse.Query(Parse.Role);
                query.equalTo("name", role_name);
                role = await query.first();
                if (role) {
                    await role.getUsers().remove(user)
                    await role.save().then(result => {

                    }).catch(e => {

                    });
                }
            },

            async createActivity(label, url, action, department, user) {
                await this.g_newActivity({
                    label_english: label,
                    label_pashto: label,
                    label_dari: label,
                    type: 'user',
                    action: action,
                    url: url,
                    createdBy: this.user.id,
                    to: null,
                    category: null,
                    class: 'User',
                    department: department,
                    reference_id: user.id
                })
            },

            async updateUser() {
                var quite = false
                if ((this.type == 'user' || this.type == 'manager') && (this.selected_departments == null || this.selected_departments.length == 0) && this.type != 'admin' && this.type != 'guest') {
                    this.$notify({
                        group: 'foo',
                        text: this._('Please select a department'),
                        duration: 4000,
                        position: 'top left',
                        type: 'warn'
                    })
                    return false
                }
                if (this.type == 'user') {
                    if (this.surveyRoles.length != 0) this.surveyRoles.push('surveys')
                    if (this.fileRoles.length != 0) this.fileRoles.push('files')
                    if (this.articleRoles.length != 0) this.articleRoles.push('articles')
                    if (this.mapRoles.length != 0) this.mapRoles.push('maps')
                    var roles = [...this.surveyRoles, ...this.fileRoles, ...this.articleRoles, ...this.mapRoles]
                    this.roles = [...roles]

                    if ((roles.includes('submitter') && roles.includes('submission-approver')) || roles.length == 0) {
                        var message = ''
                        if (roles.length == 0) {
                            message = 'Please assgin user to a role'
                        } else {
                            message = 'User can not be submitter and submission approver at the same time'
                        }
                        this.$notify({
                            group: 'foo',
                            text: this._(message),
                            duration: 4000,
                            position: 'top left',
                            type: 'warn'
                        })
                        return false
                    }
                }

                this.$refs.form.validateFields(async result => {
                    if (result.isvalid) {
                        this.$store.commit('setLoading', true)

                        // after validation

                        // 1. name
                        this.viewedUser.set('name', this.name)

                        // 2. type & roles
                        if (this.type == "manager" || this.type == "user") {
                            this.viewedUser.set('type', this.type)
                            if (this.type == "user") {
                                this.viewedUser.set('roles', roles)
                            }

                            // 3. departments
                            var departments = [];
                            if (this.fetched_all_departments && this.selected_departments) {
                                for (let i = 0; i < this.selected_departments.length; i++) {
                                    const department_id = this.selected_departments[i];
                                    for (let j = 0; j < this.fetched_all_departments.length; j++) {
                                        const department_object = this.fetched_all_departments[j];
                                        if (department_object.id == department_id) {
                                            departments.push(department_object)
                                        }
                                    }
                                }
                            }
                            this.viewedUser.set('departments', departments)
                        }

                        // 5. password
                        if (this.password != '') {
                            if (this.password.length < 6) {
                                this.$notify({
                                    group: 'foo',
                                    text: this._("Password must be atleast 6 characters"),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                })
                                quite = true
                            } else if (this.password != this.confirmPassword) {
                                this.$notify({
                                    group: 'foo',
                                    text: this._("Password doesn't match"),
                                    duration: 4000,
                                    position: 'top left',
                                    type: 'error'
                                })
                                quite = true
                            } else {
                                this.viewedUser.setPassword(this.password)
                                quite = false
                            }
                        }
                        if (quite) {
                            this.$store.commit('setLoading', false)
                            return
                        }

                        // 6. profile picture
                        this.changeUserProfilePicture()
                    }
                })
            },

            async changeUserProfilePicture() {
                if (this.viewedUser.get('profilePic')) {
                    if (this.pictureChanged && this.profilePic.img) {
                        await this.generateImage()
                            .then(async image => {
                                this.viewedUser.set('profilePic', image)
                                this.viewedUser.save()
                                    .then(async updated_user => {
                                        await this.workAfterUpdatingUserProfile(updated_user)
                                    })
                            }).catch(err => {
                                this.$store.commit('setLoading', false)
                            })

                    } else if (this.pictureChanged && !this.profilePic.img) {
                        this.viewedUser.set('profilePic', 'https://parse.nepa.gov.af/parse/files/nepa/1558358826639.png')
                        this.viewedUser.save()
                            .then(async updated_user => {
                                await this.workAfterUpdatingUserProfile(updated_user)
                            }).catch(err => {
                                this.$store.commit('setLoading', false)
                            })
                    } else {
                        this.viewedUser.save()
                            .then(async updated_user => {
                                await this.workAfterUpdatingUserProfile(updated_user)
                            }).catch(err => {
                                this.$store.commit('setLoading', false)
                            })
                    }
                } else {
                    if (this.profilePic.img) {
                        await this.generateImage()
                            .then(async image => {
                                this.viewedUser.set('profilePic', image)
                                this.viewedUser.save()
                                    .then(async updated_user => {
                                        await this.workAfterUpdatingUserProfile(updated_user)
                                    })
                            }).catch(err => {
                                this.$store.commit('setLoading', false)
                            })
                    } else {
                        this.viewedUser.set('profilePic', 'https://parse.nepa.gov.af/parse/files/nepa/1558358826639.png')
                        this.viewedUser.save()
                            .then(async updated_user => {
                                await this.workAfterUpdatingUserProfile(updated_user)
                            }).catch(err => {
                                this.$store.commit('setLoading', false)
                            })
                    }
                }
            },

            async workAfterUpdatingUserProfile(updated_user) {
                if ((this.user_type == 'admin' || this.user_type == 'manager') && (updated_user.get('type') == 'manager' || updated_user.get('type') == 'user')) await this.roleManagement(updated_user)
                await this.createActivityForUpdatingUser(updated_user)
                this.pictureChanged = false
                this.viewedUser = updated_user
                this.$store.commit('setLoading', false)
                this.$notify({
                    group: 'foo',
                    text: this._('User was updated'),
                    duration: 4000,
                    position: 'top left',
                    type: 'success'
                })
            },

            async createActivityForUpdatingUser(updated_user) {
                if (updated_user.get('type') == 'manager' || updated_user.get('type') == 'user') {
                    if (updated_user.get('departments')) {
                        for (let i = 0; i < updated_user.get('departments').length; i++) {
                            await this.createActivity(updated_user.get('name'), this.$route.path, 'edit', updated_user.get('departments')[i], updated_user)
                        }
                    }
                } else {
                    await this.createActivity(updated_user.get('name'), this.$route.path, 'edit', null, updated_user)
                }
            },

            async roleManagement(user) {
                // 1. remove user from unselected departments roles
                var new_departments = []

                if (this.fetched_all_departments && this.selected_departments) {
                    for (let i = 0; i < this.selected_departments.length; i++) {
                        const department_id = this.selected_departments[i];
                        for (let j = 0; j < this.fetched_all_departments.length; j++) {
                            const department_object = this.fetched_all_departments[j];
                            if (department_object.id == department_id) {
                                new_departments.push(department_object)
                            }
                        }
                    }
                }


                // 1.1 department role management
                for (let i = 0; i < this.old_departments.length; i++) {
                    const old_department = this.old_departments[i];
                    if (!this.selected_departments.includes(old_department.id)) {
                        await this.removeUserFromRole(user, old_department.get('slug'))
                    }
                }


                // 1.2 section role management
                if (this.type == 'user') {
                    // surveys section
                    if (this.surveys) {
                        await this.assignToThisRole(user, 'survey')
                    } else {
                        await this.removeUserFromRole(user, 'survey')
                    }
                    // articles section
                    if (this.articles) {
                        await this.assignToThisRole(user, 'article')
                    } else {
                        await this.removeUserFromRole(user, 'article')
                    }

                    // files section
                    if (this.files) {
                        await this.assignToThisRole(user, 'file')
                    } else {
                        await this.removeUserFromRole(user, 'file')

                    }

                    // maps section
                    if (this.maps) {
                        await this.assignToThisRole(user, 'map')
                    } else {
                        await this.removeUserFromRole(user, 'map')
                    }
                }


                // 2. add user to the new departments' roles
                if (this.type == 'manager') {
                    await this.assignToThisRole(user, 'manager')
                }
                for (let i = 0; i < new_departments.length; i++) {
                    const department = new_departments[i];
                    await this.assignToThisRole(user, department.get('slug'))
                }
            },

            async fetchDepartments() {
                let q = new Parse.Query('Department')
                let departments = await q.find()
                this.fetched_all_departments = departments
                this.buildDepartmentsForAllLanguages(this.fetched_all_departments)
            },

            buildDepartmentsForAllLanguages(departments) {
                this.all_departments_english = departments.map(l => {
                    return {
                        label: l.get('label_english'),
                        value: l.id
                    }
                })

                this.all_departments_pashto = departments.map(l => {
                    return {
                        label: l.get('label_pashto') == '' ? l.get('label_english') : l.get('label_pashto'),
                        value: l.id
                    }
                })

                this.all_departments_dari = departments.map(l => {
                    return {
                        label: l.get('label_dari') == '' ? l.get('label_english') : l.get('label_dari'),
                        value: l.id
                    }
                })


            },

            async fetchUser() {
                // 1. set general stuff
                this.loadingUserProfile = true
                this.viewedUser = await this.g_fetchObject(this.$route.params.id, 'User')
                this.name = this.viewedUser.get('name')
                this.email = this.viewedUser.get('username')
                this.profilePicUrl = this.viewedUser.get('profilePic')
                this.type = this.viewedUser.get('type')
                this.old_departments = this.viewedUser.get('departments')


                // 2. set roles if type is user
                // 2.1 fetch user roles
                this.viewed_user_roles = await this.fetchUserRoles(this.viewedUser)
                if (this.type == 'user') {
                    this.setUserRolesToTable()
                }
            },

            setUserRolesToTable() {
                var surveyRoles = []
                var articleRoles = []
                var fileRoles = []
                var mapRoles = []

                this.viewedUser.get('roles').forEach(role => {
                    if (role.includes('survey-')) surveyRoles.push(role)
                    if (role.includes('article-')) articleRoles.push(role)
                    if (role.includes('file-')) fileRoles.push(role)
                    if (role.includes('map-')) mapRoles.push(role)
                    if (role.includes('submitter')) surveyRoles.push(role)
                    if (role.includes('submission-')) surveyRoles.push(role)
                })

                // if (surveyRoles.length != 0) this.surveys = true
                // if (articleRoles.length != 0) this.articles = true
                // if (fileRoles.length != 0) this.files = true
                // if (mapRoles.length != 0) this.maps = true
                this.$nextTick(() => {
                    if (this.viewed_user_roles) {
                        for (let i = 0; i < this.viewed_user_roles.length; i++) {
                            const role = this.viewed_user_roles[i];
                            if (role.get('name') == 'survey') {
                                this.setSurveysValue(true)
                            } else if (role.get('name') == 'article') {
                                this.setArticlesValue(true)
                            } else if (role.get('name') == 'file') {
                                this.setFilesValue(true)
                            } else if (role.get('name') == 'map') {
                                this.setMapsValue(true)
                            }
                        }
                    }
                })

                this.surveyRoles = [...surveyRoles]
                this.articleRoles = [...articleRoles]
                this.fileRoles = [...fileRoles]
                this.mapRoles = [...mapRoles]
            },

            async fetchings() {
                // 1. check if the user is admin or manager, check by role
                if (this.user) {
                    this.$store.commit('setLoading', true)
                    this.user_type = this.g_checkIfUserIsAdminOrManagerByRole()
                    // 2. if new user is being created
                    if (this.$route.params.id == 'new') {
                        // 1. if user is admin, then fetch all department, if manager, then fetch the manager's deparments (from state)
                        if (this.user_type == 'admin') {
                            await this.fetchDepartments()
                        } else if (this.user_type == 'manager') {
                            this.fetched_all_departments = this.getUserDepartmentsFromState
                            this.buildDepartmentsForAllLanguages(this.fetched_all_departments)
                        }

                        // 3. if user is being updated
                    } else if (this.$route.params.id != 'new') {
                        // 3.1. set the user to viewedUser, and its roles
                        await this.fetchUser()

                        // 3.2 check if user is admin to manager, set departments accordingly
                        if (this.user_type == 'admin') {
                            await this.fetchDepartments()
                        } else {
                            this.fetched_all_departments = this.getUserDepartmentsFromState
                            this.buildDepartmentsForAllLanguages(this.fetched_all_departments)
                        }

                        // 3.3 set viewedUser departments to selected_departments, if the user is manager or type is user
                        if (this.viewedUser && (this.viewedUser.get('type') == 'manager' || this.viewedUser.get('type') == 'user') && this.viewedUser.get('departments') && this.viewedUser.get('departments').length != 0) {
                            var temp_selected_departments = []
                            for (let i = 0; i < this.viewedUser.get('departments').length; i++) {
                                const user_department = this.viewedUser.get('departments')[i];
                                for (let j = 0; j < this.fetched_all_departments.length; j++) {
                                    const department = this.fetched_all_departments[j];
                                    if (user_department.id == department.id) {
                                        this.manager_can_edit_this_user = true
                                        temp_selected_departments.push(user_department.id)
                                    }
                                }
                            }
                            this.selected_departments = [...temp_selected_departments]
                        } else if (this.viewedUser.get('type') == 'guest') {
                            this.manager_can_edit_this_user = true
                        }
                    }

                }
                this.$store.commit('setLoading', false)
            }
        },
        async mounted() {
            await this.fetchings()
        }
    };
</script>

<style>
    .about_permissions {
        margin-left: 20px;
        color: gray
    }

    .about_permissions:hover {
        cursor: pointer;
        text-decoration: underline
    }

    .signUpHeader {
        font-size: 20px;
        color: black;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 25px;
        margin-bottom: 30px;
        background-color: aliceblue;
    }

    .switchWrapper {
        display: inline;
        opacity: .5;
    }

    .switchEnabled {
        opacity: 1;
    }

    .disabled {
        cursor: not-allowed;
    }

    .toppedTd {
        display: flex;
    }

    .image_uploading_status {
        opacity: 0.4 !important;
    }

    .user_registeration_department .va-btn-group {
        width: 100% !important;
    }

    .user_registeration_department .va-btn-group .va-select-multiple {
        width: 100% !important;
        overflow: auto
    }
</style>